import Menu from '@mui/material/Menu'
import React, {useState} from 'react'
import {useCountFilters} from 'entities/searchPeople'
import {SPAgeFromTo, SPContinents, SPFindMe} from 'features/searchPeople'
import {ConfigFilter} from 'shared/ui/icons'
import styles from './styles.module.scss'

export const FilterButton: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isOpen = Boolean(anchorEl)
  const countFilters = useCountFilters()

  return (
    <>
      <button
        className={`${styles.configFilterButton} ${isOpen ? styles.active : ''}`}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <ConfigFilter />
        Filter
        <div className={styles.count}>({countFilters})</div>
      </button>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        classes={{
          paper: 'override-popup-paper',
          list: 'override-popup-list'
        }}
        transformOrigin={{
          vertical: -4,
          horizontal: 'left'
        }}
      >
        <div className={styles.popup}>
          <div className={styles.popupItem}>
            <label className={styles.label}>Continents:</label>
            <SPContinents sizePopup='xs' />
          </div>
          <div className={styles.popupItem}>
            <label className={styles.label}>Find me:</label>
            <SPFindMe />
          </div>
          <div className={styles.popupItem}>
            <label className={styles.label}>Age:</label>
            <SPAgeFromTo style={{flex: 1}} />
          </div>
        </div>
      </Menu>
    </>
  )
}